<template>
  <div class="mobileLgWrap_he">
    <van-nav-bar class="userNavBar"
                 @click-left="onClickLeft"
                 title="注册"
                 left-arrow>
      <template #left>
        <van-icon name="../../../static/images/mobile/back.png"
                  size="18" />
      </template>
    </van-nav-bar>
    <div class="loginMain_he">
      <van-form>
        <van-cell-group>
          <van-field v-model="mobile"
                     placeholder="请输入手机号"
                     type="number"
                     name="mobile"
                     clearable
                     label-align="left" />
          <van-field name="pattern"
                     :rules="[{ pattern, message: '请输入8-16位字母和数字组合密码' }]"
                     @click-right-icon="changeType"
                     :formatter="formatter"
                     v-model="password"
                     clearable
                     placeholder="请输入8-16位密码,字母+数字"
                     :right-icon="rightIcon"
                     :type="pwdType" />
          <van-field @input="changColor"
                     v-model="yzm"
                     placeholder="请输入短信验证码"
                     type="number"
                     name="yzm"
                     clearable
                     label-align="left">
            <van-button slot="button"
                        size="small"
                        plain
                        type="info"
                        @click="sendMessage"
                        :disabled="sendCodeBtnDisabled">{{
							sendCodeCaption
						}}</van-button>
          </van-field>
          <div :class="passwordNum > 0 ? 'onLoginbtn' : ' mobileLoginBtn_he'"
               @click="register()">
            <span><a href="javascript:;">注册</a></span>
          </div>
        </van-cell-group>
      </van-form>
    </div>
    <div class="agreement">
      <van-checkbox icon-size=".32rem"
                    v-model="checked"
                    shape="square"><span @click="goAgreement">阅读并同意《用户使用协议》和《注册协议》</span></van-checkbox>
    </div>
  </div>
</template>

<script>
import md5 from 'js-md5'
import { Toast } from 'vant'
export default {
  data() {
    return {
      mobile: '',
      text: '',
      digit: '',
      number: '',
      password: '',
      loadingFlg: false,
      loginDisable: false,
      disabled: false,
      yzm: '',
      seen: '',
      seenAgain: '',
      pwdType: 'password', // 密码类型
      rightIcon: 'closed-eye',
      type: 'register',
      sendCodeBtnDisabled: false,
      sendCodeCaption: '获取验证码',
      refreshTimer: null,
      phoneNum: '',
      passwordNum: '',
      checked: false,
      pattern: /^\w{8,16}$/
    }
  },
  methods: {
    // 过滤密码空格
    formatter(value) {
      return value.replace(/\s+/g, '')
    },
    changColor(e) {
      this.passwordNum = e.length
    },
    // 隐藏显示密码
    changeType() {
      this.pwdType = this.pwdType === 'password' ? 'text' : 'password'
      this.seen = !this.seen //小眼睛的变化
      if (this.seen) {
        this.rightIcon = 'eye-o'
      } else {
        this.rightIcon = 'closed-eye'
      }
    },
    isExistMobile() {
      let param = {}
      param.type = this.type
      param.mobile = this.mobile
      this.$api.get('/user/isExistMobile', param, (res) => {
        if (res.status == 1) {
          Toast(res.message)
          return false
        } else {
          let param = {}
          param.type = this.type
          param.mobile = this.mobile
          this.$api.get('/user/sendyanzheng', param, (res) => {
            if (res.status == 0) {
              Toast('已发送到您的手机')
              this.countDown()
            } else {
              Toast(res.message)
            }
          })
        }
      })
    },
    // 发送验证码
    sendMessage() {
      // 先判断手机号是否为空 为空输入手机号
      if (this.mobile == '') {
        Toast('请输入手机号')
        return false
      } else if (!this.$util.isPhoneNumber(this.mobile)) {
        Toast('请输入正确的手机号')
        return false
      }
      this.isExistMobile()
    },
    // 检查验证码是否正确
    yzmRight() {
      if (this.yzm == '') {
        return false
      }
      let param = {}
      param.type = this.type
      param.code = this.yzm
      this.$axiosPackag.getMessageByAxios(
        'GET',
        '/user/validCode',
        param,
        null,
        null,
        (resD) => {
          this.registerFun(md5(this.password))
        },
        (errorCall) => {}
      )
    },
    countDown() {
      var i = 60
      this.sendCodeBtnDisabled = true
      this.refreshTimer = setInterval(() => {
        this.sendCodeCaption = i + '秒后可重新发送'
        i = i - 1
        if (i == 0) {
          this.clearCountDown()
        }
      }, 1000)
    },
    clearCountDown() {
      this.sendCodeBtnDisabled = false
      this.sendCodeCaption = '获取验证码'
      clearInterval(this.refreshTimer)
    },

    /**
     * 登录
     */
    register() {
      if (this.mobile == '') {
        Toast('请先输入手机号')
        return false
      }
      if (this.password == '') {
        Toast('请输入密码')
        return false
      }
      if (this.yzm == '') {
        Toast('请输入验证码')
        return false
      }
      if (this.checked == false) {
        Toast('未勾选用户《使用协议》和《隐藏政策》')
        return false
      }
      this.yzmRight()
    },
    /**
     * 登录函数
     */
    registerFun(md5Password) {
      // 先判断手机号是否为空 为空输入手机号
      let param = {}
      param.mobile = this.mobile
      param.mypassword = md5Password
      this.$axiosPackag.getMessageByAxios(
        'POST',
        '/user/register2Done',
        param,
        null,
        null,
        (resD) => {
          if (resD) {
            Toast('注册成功')
            this.$router.push({ path: '/mobileLogin' })
          }
        },
        (errorCall) => {}
      )
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    goAgreement() {
      this.$router.push({ path: '/mobileAgreement' })
    }
  }
}
</script>
<style>
.userNavBar .van-nav-bar__title {
  font-weight: 600;
}
</style>
<style scoped>
.userNavBar {
  width: 100%;
  margin-top: 0.133333rem;
}
.mobileLgWrap_he {
  background: none;
}
.van-cell,
.van-cell-group {
  background: none;
}
.van-cell {
  background: none;
}
.van-icon-eye-o::before {
  color: #6d7174;
}
.van-cell::after {
  border: none;
}
.van-cell {
  border-bottom: 1px solid #dfdede;
  margin-bottom: 0.72rem;
}
[class*='van-hairline']::after {
  border: none;
}
/* .van-icon-eye-o::before {
} */
.budgeMobileInput {
  width: 6.933333rem;
}
.senMsg {
  display: inline-block;
  padding: 5px 10px;
  margin: 5px 0;
  color: #ffffff;
  border-radius: 8px;
  font-size: 12px;
  position: absolute;
  right: 0.32rem;
  top: 0.08rem;
}
.bd_he {
  position: relative;
}
.budgeMobileDia {
  width: 5.093333rem;
}
.agreement {
  margin-top: 3rem;
}
.agreement span {
  color: #1989fa;
}
.van-checkbox .van-icon-success {
  width: 0.32rem;
  height: 0.32rem;
}
.van-button {
  border: none;
}
.van-field {
  padding: 0.213333rem 0 0.213333rem 0;
}
.van-button--small {
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// MobileRegister.vue?4e1a6c0a